<!-- PROFILE -->
<template>
    <v-row no-gutters class="fill-height">  
        <!-- // * LEFT PANEL -->
        <v-col cols="12">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col cols="12">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text> 
                            <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.text`) }}</app-text>                                                
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <!-- <pre>{{ form }}</pre> -->
            <v-col class="my-2 px-2 d-flex align-center justify-center" cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                <!-- <v-img lazy-src="/img/tfw_logo.043f9b33.png" max-height="100%" max-width="100%" style="border-radius: 5px" :src="form.profilePicFileURL"></v-img> -->
            </v-col>
            <v-col class="my-2 px-2" cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
                <v-text-field color="black" class="py-2" :label="$t(`fields.name`)" v-model="form.userName" filled hide-details="auto" required :rules="rules.userName" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                <v-text-field color="black" class="py-2" :label="$t(`fields.jobTitle`)" v-model="form.userJobTitle" filled hide-details="auto" required :rules="rules.userJobTitle" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                <v-text-field color="black" class="py-2" :label="$t(`fields.email`)" v-model="form.userEmail" filled hide-details="auto" required :rules="rules.userEmail" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                <v-text-field color="black" class="py-2" :label="$t(`fields.telephone`)" v-model="form.userTelephone" filled hide-details="auto" required :rules="rules.userTelephone" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
            </v-col>
            <v-row class="mt-2 mx-1" no-gutters>
                <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <!-- // * FORM -->   
                    <v-row class="px-2 mt-2" no-gutters>
                        <!-- <div class="text--h6">{{ GET_currentUser.createdUserData.userName }}</div> -->
                    </v-row>        
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            langPath: 'profile',
            collection: 'users',
            collectionTitle: 'Users',
            collectionItem: 'user',
            collectionItemTitle: 'User',
            // * FORM RELATED
            form: {
                id: '',
                idFileId: null,
                host: {
                    hostId: '',
                    hostEmail: '',
                    userName: ''
                },
                userStatus: '',
                userName: '',
                userEmail: '',
                userTelephone: '',
                userJobTitle: '',
                userStaffContact: false,
                userContactType: '',
                userIsHost: null,
                organisation: {
                    organisationId:'',
                    organisationName: '',
                    organisationType: ''
                },
                profilePicFileURL: '',
                userType: '',
                userRole: '',
                lastSite: {
                    siteId: '',
                    siteName: ''
                },
                lastLocation: {
                    locationId: '',
                    locationName: ''
                },
                swappStatus: null,
                swappMethod: '',
                
            },
            rules: {},
            formMode: 'View', // Show Form in New Mode / Blank
            formReadOnly: true, // Make Form Editable
            formBackground: 'grey lighten-3',
        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_currentUser: 'GET_currentUser',
                GET_lookupValues: 'GET_lookupValues',      
                GET_help: 'GET_help',
                GET_organisations: 'GET_organisations',
                GET_sites: 'GET_sites'                                          
            }),
            // Computed Cols
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openUser', 'ACT_openUser': 'ACT_openUser'}),  
            // OPEN ITEM
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_currentUser; // Get Open Item Data
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            }
        },
        async mounted() {
           var t = this;
            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_currentUser; // Get Open Project Data
            // console.log(JSON.stringify(t.GET_currentUser))

            // console.log(JSON.stringify(openItem))
            t.formMode = openItem.process; // Show Form in View Mode
            //console.log('openItem' + JSON.stringify(openItem, null, 2))
            t.form = openItem.data; // Update the Form with the Open Project details    
            t.formReadOnly = true;
            t.formBackground = 'grey lighten-3';
            }
        }
    
</script>